<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="3">
          <div class="user-card">
            <div class="user-card__picture">
              <img
                src="https://images03.nicepage.com/c461c07a441a5d220e8feb1a/a34196cae77150c4bdcce123/7.jpg"
              />
            </div>
            <div class="user-card__info">
              <List class="user-card__social">
                <li class="orcid">
                  <a
                    href="https://orcid.org/0000-0003-0653-0224"
                    target="_blank"
                  >
                    <img
                      src="https://repositorio.igp.gob.pe/themes/Mirage/images/orcid.png"
                    />
                    0000-0003-0653-0224
                  </a>
                </li>
                <li class="ctivitae">
                  <a
                    href="https://ctivitae.concytec.gob.pe/appDirectorioCTI/VerDatosInvestigador.do?id_investigador=0003107"
                    target="_blank"
                  >
                    <img
                      src="https://repositorio.igp.gob.pe/themes/Mirage/images/ctivitae.png"
                    />
                    0003107
                  </a>
                </li>
                <li class="scopus">
                  <a
                    href="https://www.scopus.com/authid/detail.uri?authorId=24167181500"
                    target="_blank"
                  >
                    <img
                      src="https://repositorio.igp.gob.pe/themes/Mirage/images/scopus.png"
                    />
                    24167181500
                  </a>
                </li>
                <li class="email">
                  <a href="mailto:fsilva@igp.gob.pe" target="_blank">
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Logo_Gmail_%282015-2020%29.svg/1280px-Logo_Gmail_%282015-2020%29.svg.png"
                    />
                    fsilva@igp.gob.pe
                  </a>
                </li>
              </List>
              <Button
                tag="a"
                href="https://repositorio.igp.gob.pe/discover?field=author&filtertype=author&filter_relational_operator=equals&filter=Silva+Vidal%2C+Yamina"
                target="_blank"
              >
                Publicaciones
              </Button>
            </div>
          </div>
        </ColumnUi>
        <ColumnUi md="9">
          <Title tag="h1">SILVA VIDAL DE MILLONES FEY YAMINA</Title>
          <h4>INVESTIGADORA PRINCIPAL</h4>
          <p>
            Ph.D in Physics and Mathematics, Msc. In Engineering e Ingeniero
            Meteorólogo Clase I por el Instituto Estatal de Hidrometeorología de
            Rusia -San Petersburgo. Durante mi formación académica me
            especialicé en modelado numérico de la atmósfera, orientado
            principalmente a los procesos asociados a formación de lluvias. En
            la tesis para optar el título de Ingeniero desarrollé un modelo para
            parametrizar las nubes convectivas. En la tesis de doctorado, adapté
            el modelo global del Centro de Meteorológico de Rusia a un modelo
            regional para América del Sur, con el objetivo de modelar las
            variaciones de las condiciones atmosféricas en esta región, haciendo
            cambios en las parametrizaciones de superficie y nubosidad. Se
            simularon las condiciones atmosféricas durante El Niño
            extraordinario (1982/1983). Desde 1998, que regresé a Perú, hasta el
            año 2003 trabajé con el modelo MM5 en el Instituto Geofísico del
            Perú, evaluando y buscando la mejor configuración que reproduzca las
            condiciones atmosféricas del Perú. Entre los años 1999-2003, me
            dediqué a evaluar el impacto del Fenómeno El Niño en las lluvias en
            el Perú, tema que aún mantengo el interés desde el punto de vista de
            las teleconexiones. Desde el año 2003 al 2014, concentré mi trabajo
            en estudiar la variabilidad del clima en los Andes a diferentes
            escalas de tiempo: estacional, intraestacional, interanual, decadal,
            tendencias y cambio climático y los eventos meteorológicos extremos.
            La zona donde he desarrollado los principales estudios y
            publicaciones es la cuenca del río Mantaro (Andes centrales de
            Perú). Actualmente, lidero una nueva línea de investigación en el
            Perú, sobre Física de la Atmósfera con el objetivo de entender los
            procesos físicos, dinámicos y microfísicos asociados a la
            variabilidad climática en los Andes, con énfasis en las
            precipitaciones y heladas, para ello se ha implementado el
            Laboratorio de Microfísica Atmosférica y radiación -LAMAR, en el
            Obser. Huancayo-IGP.
          </p>
          <Title tag="h4">Intereses</Title>
          <p>
            Ecology of Deep-Sea Hydrothermal Vents; Discovery of Marine Natural
            Products; Larval Ecology of Marine Invertebrates; Molluscan Shell
            Structure and Mineralogy; Marine Fisheries and Aquaculture
          </p>
          <Title tag="h4">Habilidades</Title>
          <p>
            Ecology of Deep-Sea Hydrothermal Vents; Discovery of Marine Natural
            Products; Larval Ecology of Marine Invertebrates; Molluscan Shell
            Structure and Mineralogy; Marine Fisheries and Aquaculture
          </p>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import programs from "@/data.js";
import Container from "@/components/ui/objects/Container";
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title.vue";
import Row from "../components/ui/atoms/Row.vue";
import ColumnUi from "../components/ui/atoms/ColumnUi.vue";
import List from "../components/ui/objects/List.vue";
import Button from "../components/ui/atoms/Button.vue";
//import Content from "@/components/common/Content.vue";
export default {
  components: {
    Container,
    Trail,
    Title,
    Row,
    ColumnUi,
    List,
    Button
    //Content
  },
  setup() {
    const program = programs[process.env.VUE_APP_PREFIX];
    const content = program.about;
    return {
      content
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/tools/_mixins.scss";
@use "@/assets/styles/settings/_variables.scss";
.user-card {
  padding-bottom: 3em;
  margin-top: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__picture {
    margin-bottom: 1rem;
    max-width: 250px;
    img {
      border-radius: 50%;
      transition: transform 0.2s;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__name {
    font-size: 20px;
    text-transform: uppercase;
    a {
      color: currentColor;
      text-decoration: none;
    }
  }
  &__social {
    margin-bottom: 2rem;
    & > li {
      margin-bottom: 1rem;
      a {
        display: grid;
        grid-template-columns: 30px auto;
        column-gap: 1em;
        color: currentColor;
        line-height: 1;
        align-items: center;
      }
      img {
        height: 30px;
        //filter: sepia(100%) hue-rotate(170deg) saturate(200%);
        filter: grayscale(1);
        transition: transform 0.2s;
      }
      &:hover img {
        filter: none;
      }
    }
  }
}
</style>
